
var mediaStimOrder = [];
var mediaResponseEnabled = false;

function playAuxiliaryAudio(audioOptions, afterLoadedCallback) {
  mediaResponseEnabled = false;
  window.loopAudio = false;
  const audioSrc = audioOptions.filename;
  var ITIValue = parseInt(window.columnForTrial('ITI', window.trialRow));
  window.audioContainer = document.getElementById('audio1');
  var audio = window.audioContainer;

  if(window.enable_media_preload) {
    audio.src = window.preloadedMediaFiles[trialRow][0].src;
  }
  else {
    audio.src = 'stimuli/' + audioSrc + '?ts=' + startPreloadTime;
  }
  if (!isNaN(ITIValue) && ITIValue > 0){
    audio.addEventListener('canplaythrough', afterLoadedCallback, {
        // This ensures that call it only once. If it's on repeat it is called multiple times (in Chrome at least).
        // Otherwise, the showImages/words is called multiple times and alters the trial presentation
        once: true
    });
  }
  else {
    afterLoadedCallback();
  }

  if (audioOptions.loop) {
    audio.loop = true;
    window.loopAudio = true;
  } else {
    // make sure it's not on loop from previous trial
    audio.loop = false;
    window.loopAudio = false
  }

  if (audioOptions.end) {
    window.stopAudioOnNewTrial = false;
  } else {
    window.stopAudioOnNewTrial = true;
  }

  if (audioOptions.trials) {
    window.audioStopCountdown = audioOptions.trials;
  }

  if(audioOptions.time) {
    window.setTimeout(function() {
      window.stopBackgroundAudio();
    }, 1000 * audioOptions.time);
  }

  audio.addEventListener('ended', onEnd);
  audio.addEventListener('pause', onEnd);
  audio.addEventListener('error', reloadAudio);

  // delay audio playback if defined in the audio options
  if (audioOptions.delay) {
    console.log('delaying audio load by', audioOptions.delay, 'ms');
    postpone(function() {
      audio.setAttribute('autoplay', 'true');
      audio.load();
    }, audioOptions.delay);
  } else {
    audio.setAttribute('autoplay', 'true');
    audio.load();
  } 

  function onEnd() {
      if (window.loopAudio) {
        window.loopAudio = false;
      }
      audio.removeEventListener('canplaythrough', afterLoadedCallback);
      audio.removeEventListener('ended', onEnd);
      audio.removeEventListener('pause', onEnd);
      audio.removeEventListener('error', reloadAudio);
  }

  function reloadAudio(){
    if(window.inPreviewMode) {
      const mediaFilename = this.src.split('/').pop().split('?')[0];
      displayText("content", "Failed to play: <pre id='preloadErrorMessage' style='display:inline'>"+ mediaFilename +"</pre>");
      return;
    }

    alert('audio failed loading, retrying in 10s');
    setTimeout(function(){
      window.audioContainer.load();
    }, 10000);
  }
}

function playSoundsAndMovies()
{
    mediaResponseEnabled = false;
    document.getElementById("cross").style.display = "none";//hide fixation cross if any

    nThis = listNoStim[trialRow];
    mediaStimOrder = getMediaStimOrder(trialRow);
    thisNo = 1;

    thisISI = window.listTrialScreensTimings[trialRow][thisNo - 1].isi;

    if(listStimType[trialRow]==4)//movies
    {
      // thisContainer = "video1";
      stimContainers[1] = document.getElementById('video1');
    }
    else //sounds
    {
      // thisContainer = "audio1";
      stimContainers[1] = document.getElementById('audio1');
    }

    if (trialInfo.hasAutoplay) {
      stimContainers[1].setAttribute('autoplay','true');
    } else {
      stimContainers[1].removeAttribute('autoplay');
    }

    stimContainers[1].controls = trialInfo.hasControls;
    stimContainers[1].loop = trialInfo.hasLoop;
    stimContainers[1].muted = trialInfo.isMuted;

   currentWidth = 0;
   currentHeight = 0;
   playThis();

   showTrialInfo();//only displays if selected

}

function getVideoDimensions()
{
  stimContainers[1].width = stimContainers[1].videoWidth * adjuster;
  stimContainers[1].height = stimContainers[1].videoHeight * adjuster;

  if (columnForTrial('stimSize', trialRow) !== 'na') {
    const newVideoSizeFunction = listStimSizeFunctions[trialRow][0];
    const newSize = newVideoSizeFunction(stimContainers[1].width, stimContainers[1].height)
    stimContainers[1].width = Math.round(newSize.width * adjuster);
    stimContainers[1].height = Math.round(newSize.height * adjuster);
  }

  var containerTop = (canvasHeight/2 - stimContainers[1].height/2);

  stimContainers[1].style.top = containerTop + "px";
  stimContainers[1].style.left = (canvasWidth/2 - stimContainers[1].width/2) + "px";

  // should adjust the text position
  const trialTextOptions = window.columnForTrial('trialTextOptions', window.trialRow)
  var shouldShowTrialText = false;

  if(trialTextOptions.indexOf('allStim')>-1 || trialTextOptions.indexOf('allTrial')>-1 || trialTextOptions.indexOf('withStim')>-1){
    shouldShowTrialText = true;
  }

  if ((listArrays[allColumns.indexOf('waitStimEnd')][trialRow]=="na" || shouldShowTrialText) && thisNo == 1){
    minImagesTop = containerTop;
    showTrialTextForScreen(trialRow, thisNo - 1);
  }
}

function showContainer()
{
  stimContainers[1].style.display="block";

  const trialTextOptions = window.columnForTrial('trialTextOptions', window.trialRow)
  var shouldShowTrialText = false;

  if(trialTextOptions.indexOf('allStim')>-1 || trialTextOptions.indexOf('allTrial')>-1 || trialTextOptions.indexOf('withStim')>-1){
    shouldShowTrialText = true;
  }

  if ((listArrays[allColumns.indexOf('waitStimEnd')][trialRow]=="na" || shouldShowTrialText)){
    var containerTop = (canvasHeight/2 - (stimContainers[1].height || stimContainers[1].offsetHeight) /2);
    minImagesTop = containerTop;
    showTrialTextAllStim(trialRow, minImagesTop);
    showTrialTextAllTrial(trialRow, minImagesTop);
    showTrialTextForScreen(trialRow, thisNo - 1);
  }
}

function playThis()
{
  if(window.enable_media_preload) {
    stimContainers[1].src = window.preloadedMediaFiles[trialRow][thisNo].src;
  }
  else {
    stimContainers[1].src = stimUrl(mediaStimOrder[thisNo - 1], trialRow) + '?ts=' + startPreloadTime;
  }

  stimContainers[1].addEventListener('play', playStarted);
  stimContainers[1].addEventListener('error', reloadMedia);

  if (listStimType[trialRow]==4)//movies
  {
    stimContainers[1].addEventListener('loadedmetadata', getVideoDimensions);
    stimContainers[1].addEventListener('canplaythrough', showContainer);
  }

  if (listStimType[trialRow]==3)//audio
  {
    showContainer();
  }

  stimContainers[1].addEventListener('ended', endThis);

  stimContainers[1].load();


}

function reloadMedia(){
  if(window.inPreviewMode) {
    const mediaFilename = this.src.split('/').pop().split('?')[0];
    displayText("content", "Failed to play: <pre id='preloadErrorMessage' style='display:inline'>"+ mediaFilename +"</pre>");
    return;
  }

  alert('media play failed, retrying in 10s');
  setTimeout(function(){
    stimContainers[1].load();
  }, 10000);
}

function playStarted(){
  if(thisNo == 1){
    window.enableResponseWindowAtTrialStart(trialRow);
  }
  window.enableResponseWindowWithStim(trialRow);
  if(thisNo == nThis && !mediaResponseEnabled){
    timeInMs = performance.now();
    window.enableResponseWindowLastStim(trialRow);
    mediaResponseEnabled = true;
  }
  showTimer();//only displays if selected
}

function endThis()
{
  stimContainers[1].removeEventListener('ended',endThis);
  stimContainers[1].removeEventListener('error', reloadMedia);

  if (!trialInfo.keep) {
    stimContainers[1].style.display="none";
  }

  if (thisNo == nThis)
  {
    console.log("thisNo == nThis: ");
    //auto-advance if required
    if (listArrays[allColumns.indexOf('type')][trialRow]=="learn") {
      autoAdvance();
    }
    //otherwise
    else
    {
      hideTextAfterLastStim(trialRow);
      // multiple key responses
      var trialOptions = window.listTrialResponseOptions[window.trialRow] || {};
      var shouldRecordMultipleKeys = Boolean(trialOptions.multipleResponses);
      // if we have multiple keys to record and we recorded the maximum required, then we can move to the next trial
      if (shouldRecordMultipleKeys && window.trialKeysPressedCounter >= trialOptions.multipleResponses.max) {
        nextTrialWithKeys(window.keysTrial);
        return;
      }

      // presentation time finished, but did not reach minimum yet, will end once minimum is reached
      if(shouldRecordMultipleKeys){
        trialOptions.multipleResponses.presentationFinished = true;
      }

      if(columnForTrial('responseWindow', trialRow).indexOf('afterStim') >= 0) {
        window.enableResponseWindowAfterStim(trialRow);
      }

      if (listArrays[allColumns.indexOf('waitStimEnd')][trialRow]!="na") {
        var containerTop = (canvasHeight/2 - (stimContainers[1].height  || stimContainers[1].offsetHeight)/2);
        minImagesTop = containerTop;
        showTrialTextForScreen(trialRow, thisNo - 1);
        window.enableResponseWindowAfterStim(trialRow);
      }
    }
  }
  else
  {
    var currentRealISI = performance.now();
    console.log("thisNo < nThis");
        showTrialTextISIForScreen(trialRow, thisNo - 1);
        thisNo = thisNo + 1;
        setTimeout(function(){
          currentRealISI = performance.now() - currentRealISI;
          window.realISI_temp.push(currentRealISI | 0);
          window.hideTrialText(trialRow);
          playThis();
        },thisISI);
        thisISI = window.listTrialScreensTimings[trialRow][thisNo - 1].isi;
  }

}

function stimUrl(stimIndex, trialRow) {  
  let url = locationStim;

  if (isTrialFromList(trialRow)) {
    const stim = getStimFromListsForTrialByIndex(trialRow, stimIndex - 1);

    return url + stim;
  }

  const stimFileName = getStimForTrialRow(trialRow, stimIndex - 1);
  url = url + stimFileName;

  return url;
}


// returns true if we have any audio or video in the trial file
function projectHasMedia(listStimType) {
  // check trial files
  var hasMediaTrials = function() {
      return listStimType.some(function(type) {
      return type === 3 || type === 4; // audio or video types
    });
  };

  var hasAuxiliaryAudio = function() {
    var audioColumnName = 'audio';
    if (!columnIsDefined(audioColumnName)) {
      return false;
    }
    var audionColumnArray = columnArray(audioColumnName);
    return Array.isArray(audionColumnArray) && audionColumnArray.some(function(auxAudio) {
      return auxAudio && auxAudio !== 'na';
    })
  }

  return hasMediaTrials() || hasAuxiliaryAudio();
}

// show a button that once pressed a small video/audio is played so the element audio/video is enabled to auto-play in the future
function showEnableMediaAutoPlay() {
  window.screenType = 'enableMediaAutoPlay';
	window.seenEnableMediaAutoPlay = true;
  console.log('enableMediaAutoPlay');
  var audio = document.getElementById('audio1');
  var silentAudio = 'data:audio/aac;base64,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';
  audio.src = silentAudio;
  var video = document.getElementById('video1');
  video.src = silentAudio;

  audio
    .play()
    .then(function () {
      console.log('Audio auto play worked. Nothing to do here. Moving along');
      audio.pause();
      audio.src = "";
      setTimeout(function() {main()}, 10);
    })
    .catch(function(e) {
      console.error(e)
      displayText("content" , window.textScreens[window.screenType][language][0]);
      showOneButtonStandard(window.textScreens[window.screenType][language][1]);
      $('#button1').css('top','50%');
    });
}

function enableMediaAutoPlay() {
  var audio = document.getElementById('audio1');
  audio.play()
  .then(function() {
    console.log(arguments, 'eeeeesss');
    audio.pause();
    audio.src = "";
  });

  var video = document.getElementById('video1');
  video.play()
  .then(function() {
    video.pause();
    video.src = "";
  });
  setTimeout(function() {main()}, 10);
}

function getMediaStimOrder() {
  var order = [];
  for(var i = 1; i <= listNoStim[trialRow]; i++){
    order.push(i);
  }

  if(window.shouldRandomizeStimOrder(window.trialRow)){
    window.shuffle(order);
  }

  return order;
}